import * as React from 'react';
import { useFormField } from '../../utils';
import { DateInput, FormField } from '@cian/ui-kit'; // TODO: CD-127808 - сделать DayPickerInput управляемым и привязать значение инпута к значению поля в контексту формика

import { jsx as _jsx } from "react/jsx-runtime";
export var DateFieldContainer = function DateFieldContainer(props) {
  var _useFormField = useFormField({
    name: props.name
  }),
      _useFormField$helpers = _useFormField.helpers,
      setError = _useFormField$helpers.setError,
      setValue = _useFormField$helpers.setValue,
      _useFormField$meta = _useFormField.meta,
      _useFormField$meta$va = _useFormField$meta.value,
      value = _useFormField$meta$va === void 0 ? null : _useFormField$meta$va,
      error = _useFormField$meta.error,
      touched = _useFormField$meta.touched;
  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */


  var clearError = React.useCallback(function () {
    return setError(undefined);
  }, [setError]);
  var handleSetDate = React.useCallback(function (date) {
    setValue(date);

    if (date && error) {
      clearError();
    }
  }, [clearError, error, setValue]);
  var handleInputFocus = React.useCallback(function () {
    if (error) {
      clearError();
    }
  }, [clearError, error]);
  var isInvalid = Boolean(touched && error);
  return /*#__PURE__*/_jsx(FormField, {
    errorMessage: isInvalid ? error : null,
    label: props.label,
    withoutMargin: true,
    children: /*#__PURE__*/_jsx(DateInput, {
      size: "M",
      "data-testid": "daypicker_input",
      onFocus: handleInputFocus,
      onChange: handleSetDate,
      invalid: isInvalid,
      name: props.name,
      value: value
    })
  });
};
DateFieldContainer.displayName = 'DateFieldContainer';